import React, { useContext, useEffect } from 'react';
import TranslationsForm from './components/TranslationsForm';
import EditForm from './components/EditForm/EditForm';
import { EditComboGroupContext, IEditComboGroupContext } from '../../editComboGroupState/editComboGroupContext';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditComboGroupContext>(EditComboGroupContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<EditForm isVisible={visibleForm === 'mainForm'} />
			<TranslationsForm isVisible={visibleForm === 'translations'} />
		</div>
	);
};

export default Forms;
